import { create } from 'zustand';
import { createSelectors } from './createSelectors';
import { getCustomerProfile, CustomerProfileResponse } from '../apis/customerApi';

interface CustomerState {
  customerProfile: CustomerProfileResponse | null;
  getCustomerProfile: () => Promise<CustomerProfileResponse>;
}

const useCustomerStoreBase = create<CustomerState>((set) => ({
  customerProfile: null,
  getCustomerProfile: async () => {
    const customerProfile = await getCustomerProfile();
    set({ customerProfile });
    return customerProfile;
  },
}));

export const useCustomerStore = createSelectors(useCustomerStoreBase);
